import { Description } from '@monorepo/shared/componentsV2/Description';
import {
  Content,
  Page,
  Title,
} from '@monorepo/shared/componentsV2/fullPageWizard/styled/fullPageWizard';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { useWorkflow } from '@monorepo/shared/hooks/workflows/useWorkflow';
import React from 'react';
import { useParams } from 'react-router-dom-v5-compat';
import styled from 'styled-components';
import { WorkflowStepCard } from '../EditWorkflowStepsPage/WorkflowStepCard';
import { WorkflowStepsDiagram } from '../EditWorkflowStepsPage/WorkflowStepsDiagram';
import { WorkflowOutputPreview } from '../shared/WorkflowOutputPreview';
import { WorkflowDetailsHeader } from './WorkflowDetailsHeader';

const StyledContent = styled(Content)`
  margin-left: 8px;
`;

const ListContainer = styled.div`
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
`;

const StyledWorkflowStepCard = styled(WorkflowStepCard)`
  margin-bottom: 0.625rem;
`;

const OutputPreviewContainer = styled.div`
  max-width: 40rem;
  padding: 20px 0;
  border: ${({ theme }) => `1px solid ${theme.colors.grayddd}`};
  border-radius: 4px;
`;

export function WorkflowDetailsPage() {
  const { organizationId, workflowId } = useParams();
  const { workflow, isLoading: isWorkflowLoading } = useWorkflow({
    organizationId,
    workflowId,
  });
  if (isWorkflowLoading) {
    return (
      <Page>
        <Loading />
      </Page>
    );
  }

  if (!workflow || !organizationId) {
    throw new Error("Couldn't get information about this workflow.");
  }

  return (
    <Page>
      <WorkflowDetailsHeader workflow={workflow} />
      <StyledContent>
        <Title>Workflow Details</Title>
        <Description>
          {workflow.description ?? 'No workflow description.'}
        </Description>
        <WorkflowStepsDiagram
          organizationId={organizationId}
          workflowId={workflow.id}
        />
        <br />
        <Title>Steps</Title>
        <ListContainer>
          {workflow.steps.map((step) => (
            <StyledWorkflowStepCard
              key={step.id}
              organizationId={organizationId}
              showMenu={false}
              step={step}
            />
          ))}
        </ListContainer>
        <br />
        <Title>Output</Title>
        <Description>Visualization of workflow output data</Description>
        <br />
        <OutputPreviewContainer>
          <WorkflowOutputPreview
            propertyAncestry={workflow.outputDataset.propertyAncestry}
          />
        </OutputPreviewContainer>
      </StyledContent>
    </Page>
  );
}
